import styled from 'styled-components';

export const OnboardContainer = styled.div`
  width: ${(props) => (props.mobileView ? '100vw' : '581px')};
  height: ${(props) => (props.mobileView ? '100vh' : 'auto')};
  min-height: 413px;
  /* Cap to the viewport and scroll internally so taller content
     (e.g. the usage-goals survey + terms) never clips the submit button. */
  max-height: 100vh;
  overflow-y: auto;
  /* Flex column so the dialogue fills the card and can pin its action
     buttons to the very bottom regardless of how short the content is. */
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  background-color: var(--white);
  border: 1px solid #f1e6fc;
  box-shadow: 0 4px 16px 0 rgba(114, 0, 224, 0.1);
`;
